import { Box } from '@wegroup/design-system';
import React from 'react';
import IllustrationPartyHat from '../../../../common/src/assets/images/IllustrationPartyHat';

const FinalizePartyHatIllustration: React.FC = () => {
  return (
    <Box
      display={{
        base: 'none',
        tablet: 'block',
      }}
      w={{ base: '28', laptopL: '40' }}
      sx={{
        svg: {
          width: '100%',
          height: 'auto',
        },
      }}
    >
      <IllustrationPartyHat />
    </Box>
  );
};

export default FinalizePartyHatIllustration;
